import { RootState } from '@/domain/store';

export const selectProjectVenuesPresetsItems = (state: RootState) => {
  return state.projectVenuePresets.items;
};
